module.exports = __webpack_public_path__ + "static/img/2-01.165b805.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-01.png
// module id = 218
// module chunks = 0